import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Expand Icon Component
 * Arrows pointing outward from two corners (bottom-left, top-right)
 * Used for expand/maximize actions
 * HeroIcons mini style (20x20, filled)
 */
class ExpandIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20',
            fill: 'currentColor',
            stroke: 'none',
        };
    }

    renderIconPath() {
        return svg`
            <path
                d="M13.28 7.78l3.22-3.22v2.69a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.69l-3.22 3.22a.75.75 0 001.06 1.06zM2 17.25v-4.5a.75.75 0 011.5 0v2.69l3.22-3.22a.75.75 0 011.06 1.06L4.56 16.5h2.69a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75z"
            />
        `;
    }
}

customElements.define('expand-icon', ExpandIcon);
